import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { FC, useCallback } from 'react';

export type ErrorPagePresenterProps = {
  redirectToHome: () => void;
  errorMessage?: string;
};

const styles: Record<string, SxProps<Theme>> = {
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  loginTitle: {
    fontSize: '40px',
    marginBottom: '24px',
  },
};

// エラーメッセージの分岐処理
const getErrorMessage = (errorMessage?: string): string => {
  if (!errorMessage) {
    return '';
  }

  // duplicate key value violates unique constraint の判定
  // "duplicate key value violates unique constraint \"UQ_1dd5e3b85069465ecdccaec1dc0\"" のようなエラーメッセージに対応させる
  // IPアドレス登録時に発生した問題なため、バックエンド側で対応ができた場合ここの分岐は必要なくなる
  // https://app.zenhub.com/workspaces/claris-60b56db504e3ff00150ebc22/issues/gh/dkclaris/claris-general/5548
  if (errorMessage.includes('duplicate key value violates unique constraint')) {
    return '既に同じデータが存在するため登録できません。';
  }
  // 商圏店舗が存在しない場合の判定
  if (errorMessage.includes('商圏店舗が存在しません')) {
    return '商圏店舗が存在しません';
  }
  // その他のエラーメッセージは全て表示しない
  // (背景)ここでその他のメッセージを表示してしまうと、バックエンド側のエラーメッセージがそのまま表示され情報漏洩に繋がる影響が出たため、上記のIPアドレス登録時のエラー以外は全て表示しないようにする
  // https://app.zenhub.com/workspaces/claris-60b56db504e3ff00150ebc22/issues/gh/dkclaris/claris-general/5589
  return '';
};

export const ErrorPagePresenter: FC<ErrorPagePresenterProps> = (props) => {
  const { redirectToHome, errorMessage } = props;

  // エラーメッセージの分岐処理を実行
  const displayMessage = getErrorMessage(errorMessage);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={styles.root}
    >
      <Grid>
        <Paper elevation={3}>
          <Box p={3}>
            <Box mb={2}>
              <Typography variant="h6" component="h2" noWrap>
                エラーが発生しました
              </Typography>
            </Box>
            {displayMessage && (
              <Box mb={2}>
                <Typography variant="body2" color="text.secondary">
                  {displayMessage}
                </Typography>
              </Box>
            )}
            <Button color="primary" onClick={() => redirectToHome()}>
              ホームに戻る
            </Button>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export const ErrorPage: FC<{ errorMessage: string }> = ({ errorMessage }) => {
  const redirectToHome = useCallback(() => {
    window.location.href = '/';
  }, []);

  return (
    <ErrorPagePresenter
      redirectToHome={redirectToHome}
      errorMessage={errorMessage}
    />
  );
};
